import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const HowItWorksSection = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: false
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: { 
      x: 0, 
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 10
      }
    }
  };

  const rightItemVariants = {
    hidden: { x: 50, opacity: 0 },
    visible: { 
      x: 0, 
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 10
      }
    }
  };

  return (
    <section className="py-16 md:py-24 bg-black" id="how-it-works" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.h2 
          className="text-3xl md:text-4xl font-bold text-white text-center mb-12 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={controls}
          variants={itemVariants}
        >
          How Your App Works
        </motion.h2>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial="hidden"
            animate={controls}
            variants={itemVariants}
          >
            <img 
              alt="Illustration of app workflow" 
              className="w-full h-auto rounded-xl shadow-lg" 
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuAfnVrEv1AiTFXzGM3hbF1AO7nqAMXOvZIjMaTwEWey86b59u_SXzac_RwDeXto3Cmc3OHIRQCGfjQlWgMngznOg6fgA4bbqUAneCDcle2uZdRX_Q_ayWIPeJaQ2gGmwi2LoTGSszhU-J8iEknjlgwa1H1EsU_KJf9klsirqPMWjRbRXRcN4a5jmzwK9dVgOhPwUupijFRZenpuV8bhteKEDSC5FurxYM6Ues1o1dVr7E7TZJHkmejkrDUuT34Iwj_W0MhKvevvWx4G" 
            />
          </motion.div>
          <motion.div 
            className="space-y-6"
            initial="hidden"
            animate={controls}
            variants={containerVariants}
          >
            {[
              {
                step: 1,
                title: "Upload Your Minion",
                description: "Start by uploading an image of your character you want to turn into an AI avatar."
              },
              {
                step: 2,
                title: "AI Transformation",
                description: "Our advanced AI processes the image and brings your minion to life with unique characteristics and personality traits."
              },
              {
                step: 3,
                title: "Chat & Interact",
                description: "Begin conversations with your newly created AI avatar. Watch as it responds, learns, and grows with every interaction."
              }
            ].map((step, index) => (
              <motion.div 
                key={index} 
                className="flex items-start space-x-4"
                variants={rightItemVariants}
                whileHover={{ x: 5 }}
              >
                <motion.div 
                  className="flex-shrink-0 w-12 h-12 bg-white rounded-full flex items-center justify-center text-black text-xl font-bold"
                  whileHover={{ scale: 1.1, backgroundColor: "#f0f0f0" }}
                  whileTap={{ scale: 0.95 }}
                >
                  {step.step}
                </motion.div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-1">{step.title}</h3>
                  <p className="text-gray-400">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection; 